import { useQuery } from "@tanstack/react-query"
import { useLocation, useNavigate } from "react-router-dom"
import { downloadZipFromLinkPage } from "../../pages/api/apiCalls"
import { apiErrorMessage } from "../../services/apiErrorText"

export default function DownloadPage() {
    const location = useLocation()

    // Parse query parameters
    const searchParams = new URLSearchParams(location.search)

    // Get the `id` parameter
    const id = searchParams.get("id")
    const type = searchParams.get("type")

    const navigate = useNavigate()
    const { error } = useQuery({
        queryKey: ["DownloadZip" + id + type],
        queryFn: () => downloadZipFromLinkPage(`/export/download-zip?id=${id}&type=${type}`).then(() => navigate("/")),
        enabled: !!id && !!type,
        // 404/400 (Export fehlt, S3-Fehler) nicht dreimal wiederholen, sondern die Meldung zeigen
        retry: false,
    })

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center h-screen w-screen px-4 text-center">
                <p className="text-2xl font-bold">Der Download ist fehlgeschlagen</p>
                <p className="text-sm text-gray-500">{apiErrorMessage(error, "Die Datei konnte nicht heruntergeladen werden.")}</p>
            </div>
        )
    }

    return (
        <div className="flex flex-col items-center justify-center h-screen w-screen">
            <p className="text-2xl font-bold">Das Dokument wird heruntergeladen...</p>
            <p className="text-sm text-gray-500">Bitte warten Sie einen Moment...</p>
            <p className="text-sm text-gray-500">Wenn Sie nicht automatisch weitergeleitet werden, schauen Sie in Ihren Downloads nach.</p>
        </div>
    )
}
